import { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "dc_admin_token";

export function useAdminInbox() {
  const [token, setToken] = useState(() => sessionStorage.getItem(TOKEN_KEY) || "");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copiedId, setCopiedId] = useState(null);

  const fetchMessages = useCallback(async (t) => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/contact`, { headers: { "X-Admin-Token": t } });
      if (res.status === 401) {
        setError("Invalid token. Try again.");
        sessionStorage.removeItem(TOKEN_KEY);
        setToken("");
        setMessages([]);
      } else if (!res.ok) {
        setError(`Server responded ${res.status}.`);
      } else {
        const data = await res.json();
        setMessages(Array.isArray(data) ? data : []);
      }
    } catch (e) {
      if (process.env.NODE_ENV !== "production") console.error("Failed to fetch messages:", e);
      setError("Network error. Check backend.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token) fetchMessages(token);
  }, [token, fetchMessages]);

  const login = (t) => {
    sessionStorage.setItem(TOKEN_KEY, t);
    setToken(t);
  };

  const logout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken("");
    setMessages([]);
  };

  const copy = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 1400);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") console.error("Clipboard copy failed:", e);
    }
  };

  return { token, messages, loading, error, copiedId, fetchMessages, login, logout, copy };
}
